export default __webpack_public_path__ + "static/media/IO.3172438b.svg";